/** スポットの検索。県の絞り込みは地図側のフィルターにまとめてある */

import { Search, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = {
  keyword: string
  onKeywordChange: (value: string) => void
}

export const RallyItemFilterBar = ({ keyword, onKeywordChange }: Props) => (
  <div className="relative mb-3">
    <Search size={16} className="absolute top-1/2 left-3 -translate-y-1/2 text-muted-foreground" />
    <Input
      value={keyword}
      onChange={(e) => onKeywordChange(e.target.value)}
      placeholder="スポット名・住所・メモで検索"
      className="pl-9"
    />
    {keyword && (
      <Button
        variant="ghost"
        size="icon"
        aria-label="検索を消す"
        className="absolute top-1/2 right-1 size-7 -translate-y-1/2"
        onClick={() => onKeywordChange('')}
      >
        <X size={14} />
      </Button>
    )}
  </div>
)
